import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-12 bg-dark relative overflow-hidden" data-id="element-202">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent-cyan/10 rounded-full blur-[150px] pointer-events-none" data-id="element-203" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-204">
        <div className="max-w-4xl mx-auto text-center" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-206">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-207">
              EXISTE UN CAMINO{' '}
              <span className="text-gradient-primary" data-id="element-208">MÁS SIMPLE</span>
            </h2>

            <p className="text-xl md:text-2xl text-gray-300 mb-8 font-light leading-relaxed max-w-3xl mx-auto" data-id="element-209">
              Un sistema dividido en pasos simples para que avances sin
              abrumarte y consigas resultados desde el día 1.
            </p>
          </motion.div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10" data-id="element-210">
            {['Sin lenguaje técnico complicado', 'Directo a la práctica', 'Con ejemplos reales y visuales'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3 + i * 0.1
          }} className="flex items-center gap-3 text-lg text-gray-200" data-id="element-211">
                <CheckCircle2 className="w-6 h-6 text-accent-cyan shrink-0" data-id="element-212" />
                <span data-id="element-213">{item}</span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}